import { WithToolTip } from "./WithToolTip";

export default WithToolTip;
